import * as React from 'react'
import type { Color } from '../../../theme/colors'
import colors from '../../../theme/colors'

type Props = {
  width?: number,
  height?: number,
  color?: Color
}

const UserSolidSvg = ({ width, height, color }: Props) => (
  <svg width={width} height={height} viewBox="0 0 22 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.50003 8.5C9.70003 8.5 11.5 6.7 11.5 4.5C11.5 2.3 9.70003 0.5 7.50003 0.5C5.30003 0.5 3.50003 2.3 3.50003 4.5C3.50003 6.7 5.30003 8.5 7.50003 8.5ZM12 7.6C13.7 9 16.2 8.7 17.6 7C19 5.3 18.7 2.8 17 1.4C16.3 0.8 15.4 0.5 14.5 0.5C13.6 0.5 12.7 0.8 12 1.4C13.7 2.8 14 5.2 12.6 7C12.5 7.2 12.2 7.4 12 7.6ZM21.9 16.4C21.3 12.7 18.2 10 14.5 10C13.6 10 12.8 10.1 12 10.4C14.6 11.3 16.5 13.6 16.9 16.3C17 16.8 16.6 17.4 16 17.4H15.9H20.9C21.5 17.4 21.9 17 21.9 16.4C21.9 16.5 21.9 16.4 21.9 16.4ZM7.50003 10C3.80003 10 0.600031 12.7 0.100031 16.4C3.11658e-05 16.9 0.400031 17.5 1.00003 17.5H1.10003H13.9C14.5 17.5 14.9 17.1 14.9 16.5V16.4C14.4 12.7 11.2 10 7.50003 10Z"
      fill={color}
    />
  </svg>
)

UserSolidSvg.defaultProps = {
  width: 22,
  height: 18,
  color: colors.Primary.GreyText
}

export default UserSolidSvg
